module.exports = __webpack_public_path__ + "img/bell.c8aa05b3.svg";